import { FC } from "react"
import badgesBg from "assets/images/others/host-side-images/badgesBg.png";
import { ReactComponent as ReviewStarSvg } from "assets/images/svgs/reviewStarSvg.svg";
import { UserDTO } from "utils/helpers/models/shared/user.dto";
import { getFilePathWithBackendUrl } from "utils/helpers/common/http-methods";
import { siteRoutes } from "utils/helpers/enums/routes";
import { useNavigate } from "react-router-dom";

interface Props {
    host: UserDTO;
}

const HostCard: FC<Props> = ({ host }) => {
    const navigate = useNavigate();

    const goToHostDetail = () => {
        navigate(`${siteRoutes.attendeeHostProfileDetail}?id=${host.id}&hostId=${host.id}`);
    }
    console.log(host, "host in host card");
    return (
        <div
            className="flex flex-col items-center justify-center p-4 rounded-lg w-[235px] h-[260px] "
            // onClick={goToHostDetail}
            style={{
                backgroundImage: `url(${badgesBg})`,
                backgroundSize: "cover",
            }}
        >
            <div className="hover:scale-110 transition-transform duration-300">
                <img
                    className="w-[140px] h-[140px] rounded-full"
                    src={getFilePathWithBackendUrl(host.profilePicUrl?.fileDownloadUri)}
                />
            </div>
            <span className="text-base font-semibold mt-2 text-blackie">
                {`${host.firstName} ${host.lastName}`}
            </span>
            <span className="text-sm mt-1 text-labelTextColor flex items-center">
                {/* <ReviewStarSvg className="w-4 h-4 mr-1" /> {5} */}
                {host?.businessName}
            </span>
        </div>
    )
}

export default HostCard;